<template>
  <Layout>
    <div class="ev-status">

      <b-tabs content-class="tab-content-zone text-muted" nav-class="nav-tabs-custom"
              :class="{'nav-justified':$store.state.layout.browserMode === 'mobile'}">
        <template v-for="(tab, i) in tabs">
          <b-tab :key="i" :active="i === 0">
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i :class="`mdi ${tab.icon}`" />
              </span>
              <span class="d-none d-sm-inline-block">
                <i :class="`mdi ${tab.icon} icon-padding-right`" />
              </span>
              <span class="d-none d-sm-inline-block">{{ tab.title }}</span>
            </template>
            <keep-alive>
              <component :is="tab.component" :key="i" />
              <!--              <component :is="tab.component" :key="i" :lazy="true" />-->
            </keep-alive>
          </b-tab>
        </template>
      </b-tabs>

    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main';
import ChargingUse from '@/views/pages/status/chargingUse.vue';
import Station from '@/views/pages/status/station.vue';
import Charger from '@/views/pages/status/evse.vue';
import History from '@/views/pages/status/chargingHistory.vue';
import BrokenUnused from "@/views/pages/status/brokenUnused.vue";

export default {
  components: { Layout, ChargingUse, Station, Charger, History, BrokenUnused },
  data() {
    return {
      tabs: [
        { title: '충전 이용 현황', icon: 'mdi-information', component: 'ChargingUse' },
        { title: '충전소', icon: 'mdi-office-building-marker', component: 'Station' },
        { title: '충전기', icon: 'mdi-ev-station', component: 'Charger' },
        { title: '충전 이력', icon: 'mdi-clipboard-text-multiple', component: 'History' },
        { title: '고장 / 미사용', icon: 'mdi-battery-alert', component: 'BrokenUnused' },
      ]
    }
  }
}
</script>
